// extracted by mini-css-extract-plugin
export default {"templatePage":"TemplatePage-module__templatePage__wXU82"};